import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import ContactUs from "./components/ContactUs";
import Header from "./components/Header";

import "./index.css";

import ProgressTrackingLogin from "./components/ProgressTrackingLogin";
import ProgressTrackingMainPage from "./components/ProgressTrackingMainPage";
import AddSchool from "./components/AddSchool";
import AllSchools from "./components/AllSchools";
import EditSchool from "./components/EditSchool";
import AllSchoolsForParents from "./components/AllSchoolsForParents";
import StudentsBySchool from "./components/StudentsBySchool";
import AddStudent from "./components/AddStudent";
import AllStudentsAdmin from "./components/AllStudentsAdmin";
import EditStudentAdmin from "./components/EditStudentAdmin";
import TempSchoolPage from "./components/TempSchoolPage";
import Careers from "./components/Careers";
import AboutUs from "./components/AboutUs";
import ProjectKits from "./components/ProjectKits";

export default function HomePage() {
  return (
    <BrowserRouter>
      {/* 🔥 ONLY ONE MAIN WRAPPER */}
      <div className="main-container">
        {/* Fixed Top Bars */}
        <ContactUs />

        {/* Navbar */}
        <Header />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/add-school" element={<AddSchool />} />
          <Route path="/all-schools" element={<AllSchools />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/add-student/:id" element={<AddStudent />} />
          <Route path="/temp-school" element={<TempSchoolPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/project-kits" element={<ProjectKits />} />
          <Route
            path="/edit-student/:schoolId/:studentId"
            element={<EditStudentAdmin />}
          />
          <Route
            path="/all-students-admin/:id"
            element={<AllStudentsAdmin />}
          />
          <Route
            path="/student-by-school/:schoolId"
            element={<StudentsBySchool />}
          />
          <Route
            path="/all-schools-parents"
            element={<AllSchoolsForParents />}
          />
          <Route path="/edit-school/:id" element={<EditSchool />} />
          <Route
            path="/progress-tracking-main"
            element={<ProgressTrackingMainPage />}
          />
          <Route
            path="/progress-tracking-login"
            element={<ProgressTrackingLogin />}
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
